import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useMessageBus } from "@jti/fe-message-bus";
import { useUser } from "@jti/rip";
import { Toaster, Typography } from "@jti/ui";
import { ProductDescription, ProductHeading, ProductQuantityError, StockStatus } from "../../../../components";
import { ProductCarousel } from "../../../../components/ProductCarousel";
import { ProductPrice } from "../../../../components/ProductPrice";
import { SticksForm } from "../../../../forms/SticksForm";
import { useProductData, useProductDetails } from "../../../../hooks";
import { useSticksDataContext } from "../../../../providers";
import { dispatchViewItemEvent } from "../../../../utils/dispatchViewItemEvent";
import { getFilteredImagesByRole } from "../../../../utils/getFilteredImagesByRole";
import "../../../../ProductDetails.scss";
export const SticksProductDetails = () => {
    const { data, currentProduct: currentProductData } = useSticksDataContext();
    const { sku, badgeText = "", overwriteBadgeText = "", hasBadge = false, hasDiscountBadge, hasStrikethroughPrice, hidePrice, isCommerceDisabled, isSubscriptionsEnabled, } = data;
    const { isLoggedIn } = useUser();
    const messageBus = useMessageBus();
    const [isSubscriptionSelected, setIsSubscriptionSelected] = useState(false);
    const { sticksName, sticksDescription, productGalleryItems, flavor, categories, color } = useMemo(() => {
        const { name, description, flavor, categories, color } = currentProductData.current.product || {};
        const computedSticksName = name || "";
        const computedSticksDescription = description || "";
        const mediaGallery = currentProductData.current.product?.mediaGallery || [];
        const computedProductGalleryItems = mediaGallery.map((item) => ({
            ...item,
            path: item.url,
        }));
        const filteredGalleryAssets = getFilteredImagesByRole(computedProductGalleryItems, "dynamic_picture_bundle");
        return {
            sticksName: computedSticksName,
            sticksDescription: computedSticksDescription,
            productGalleryItems: filteredGalleryAssets,
            flavor,
            categories,
            color,
        };
    }, [currentProductData?.current.product]);
    const { isProductDataLoading, isProductDataLoaded, 
    // elementsStockStatus, TODO: will be needed when implementing in stock status handling on form change
    isInStock, discount, priceInformation, specialOffer, subtitle, productDisclaimer, } = useProductData({
        sku,
        pageSize: 1,
        currentVariantSku: sku,
    });
    const productDetailsConfig = {
        sku,
        priceInformation,
        hidePrice,
        isCommerceDisabled,
    };
    const { quantityLimit, isQuantityLimitReached, shouldRenderPrice, isCartLoaded } = useProductDetails(productDetailsConfig);
    useEffect(() => {
        if (isProductDataLoading) {
            return;
        }
        dispatchViewItemEvent({
            productName: sticksName,
            sku,
            color,
            flavor,
            categories,
            discount,
            priceInformation,
        });
    }, [isProductDataLoading]);
    useEffect(() => {
        if ((!isProductDataLoading && !isProductDataLoaded) || !isLoggedIn) {
            return;
        }
    }, [isProductDataLoading, isProductDataLoaded, specialOffer, isLoggedIn]);
    useEffect(() => {
        messageBus.publish("update.breadcrumb.name", {
            payload: {
                breadcrumbName: sticksName,
            },
        });
        window.document.title = sticksName;
    }, [messageBus, sticksName]);
    return (_jsxs("div", { className: "aem-productDetails__container", "data-testid": "sticks-product-details", children: [_jsx("div", { className: "aem-carousel__wrapper aem-carousel__bottomSpacing aem-productDetails__carousel", children: _jsx(ProductCarousel, { items: productGalleryItems }) }), _jsxs("div", { className: "aem-productDetails__productInfo", children: [_jsx(ProductHeading, { description: subtitle, productName: sticksName, badgeText: overwriteBadgeText ?? badgeText, hasBadge: overwriteBadgeText ? true : hasBadge }), shouldRenderPrice && (_jsx(ProductPrice, { hideDiscountBadge: !hasDiscountBadge, hideStrikethroughPrice: !hasStrikethroughPrice, priceInformation: priceInformation, discount: discount, isFetching: isProductDataLoading, showMonthlyBadge: isSubscriptionSelected })), !!productDisclaimer && (_jsx(Typography, { variant: "body1", className: "product-details__disclaimer", children: productDisclaimer })), _jsx(ProductQuantityError, { className: "product-details__quantity-error", isVisible: isQuantityLimitReached, quantityLimit: quantityLimit }), _jsx("div", { className: "product-details__sticks-form-wrapper", children: _jsx(SticksForm, { isSubscriptionsEnabled: isSubscriptionsEnabled, isOutOfStockProductSelected: !isInStock, isCartLoaded: isCartLoaded, setIsSubscriptionSelected: setIsSubscriptionSelected }) }), _jsxs("div", { className: "product-information-block", children: [_jsx(StockStatus, { isInStock: isInStock, isProductDataLoading: isProductDataLoading }), _jsx(ProductDescription, { description: sticksDescription })] }), _jsx(Toaster, {})] })] }));
};
//# sourceMappingURL=SticksProductDetails.js.map